import Base from './Base';
import { Layers } from '../constants/Layers';
import Language from './language.json';

class Ga8Custom extends Base {
  constructor(options, gameData) {
    super(options, gameData);
    this._init();
  }
  _init() {
    // css
    const css = this._css(this.options, this.gameData);
    this._insertCss(css);

    // html
    const html = this._html(this.options, this.gameData);
    const { container, extContainer } = this._insertHtml(html);

    this._root = container;
    this._container = container;
    this._extContainer = extContainer;

    // register events
    this._registerEvents();

    const loader = document.querySelector(`.${this.options.prefix}loader`);
    const playButton = document.getElementById(`${this.options.prefix}splash-button`);

    this.on('playClick', () => {
      if (loader) loader.style.display = 'block';
      if (playButton) playButton.style.display = 'none';
    });

    this._init_slots();
  }

  _css(options, gameData) {
    let thumbnail = this._getThumbnail(options, gameData);

    const css = `
            body {
                position: inherit;
            }
          
            .${this.options.prefix}splash-container {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: stretch;
              position: absolute;
              width: 100%;
              height: 100%;
              top:0;
              left:0;
              background-color:black;
              color:white;
              font-family: Helvetica, Arial, sans-serif;
              overflow: hidden;
            }

            .${this.options.prefix}splash-container::before {
              content: "";
              position: absolute;
              inset: 0;
              filter: blur(30px);
              ${this._getBackground(options, gameData)}
            }

            .${this.options.prefix}splash-top {
              border-bottom:2px solid rgba(0,0,0,0.2);
              background-color:rgba(0,0,0,0.1);
              flex-grow:1;
              display:flex;
              justify-content: center;
              align-items: center;
              display:none;
              position:relative;
              max-height:20%;              
            }

            .${this.options.prefix}splash-bottom {
              border-top:2px solid rgba(0,0,0,0.2);
              background-color:rgba(0,0,0,0.1);              
              flex-grow:1;
              display:flex;
              justify-content: center;
              align-items: center;
              display:none;
              position:relative;
              max-height:20%;                
            }
            
            .${this.options.prefix}splash-center {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              flex-grow:1;
            }

            .${this.options.prefix}splash-left {
              border-right:2px solid rgba(0,0,0,0.2);
              background-color:rgba(0,0,0,0.1);              
              flex-grow:2;
              display:flex;
              justify-content: center;
              align-items: center;
              display:none;
              position:relative;
              max-width:20%;
            }

            .${this.options.prefix}splash-right {
              border-left:2px solid rgba(0,0,0,0.2);
              background-color:rgba(0,0,0,0.1);          
              flex-grow:2;
              display:flex;
              justify-content: center;
              align-items: center;
              display:none;
              position:relative;
              max-width:20%;
            }

            .${this.options.prefix}splash-game {
              display:flex;
              flex-direction:column;
              justify-content: flex-start; 
              overflow:hidden;
              flex-grow:1;
            }
            
            .${this.options.prefix}splash-game-metadata{
              display:flex;
              flex-direction:column;
              justify-content:center;
              flex-grow:1;
              position:relative;
            }
            
            .${this.options.prefix}splash-game-consent{
              display:flex;
              justify-content:center;
              margin:0.5em;
            }

            .${this.options.prefix}splash-game-consent>p{
              text-align: justify;
              font-size: 12px;
              font-family: Arial;
              font-weight: normal;
              max-width: 300px;
            }

            .${this.options.prefix}splash-game-consent>p>a{
              color:#fff;
            }

            .${this.options.prefix}splash-game-thumbnail-play{
              flex-grow:1;
              display:flex;
              flex-direction:column;
              justify-content:center;
              align-items:center;
            }

            .${this.options.prefix}splash-game-title{
              display:flex;
              justify-content:center;
              align-items:center;
              margin:4px;
              font-size:1.5em;
              color:rgba(255, 255, 255, 0.9);  
            }

            .${this.options.prefix}splash-game-thumbnail{
              display:flex;
              justify-content:center;
              align-items:flex-end;
              position:relative;
              margin:4px;
            }

            .${this.options.prefix}splash-game-play{
              display:flex;
              justify-content:center;
              align-items:flex-start;
              margin:4px;
            }

            .${this.options.prefix}splash-game-description{
              display:flex;
              justify-content:center;
              align-items:flex-end;
              margin:4px;
              text-align: justify;
              font-size: 14px;
              font-family: Arial;
              font-weight: normal;
              color:#21A179;
            }

            .${this.options.prefix}splash-game-title>p{
              color: rgba(255, 255, 255, 1);
              font-size: 22px;
              font-weight: bold;
              max-width: 300px;
              max-height: 66px;
              line-height: 33px;
              text-align: center;
              margin: 0;
              overflow: hidden;
            }
                             
            .${this.options.prefix}splash-game-description>p{
              max-width: 300px;  
            }

            .${this.options.prefix}splash-game-thumbnail>div {
              width: 182px;
              height: 111px;
              border-radius: 6px;
              background-color:rgba(0,0,0,0.1);
              background-image: url('${thumbnail}?f=webp');
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }

            .${this.options.prefix}splash-game-play>button{
              padding: 8px;
              border-radius: 28px;
              border:0;
              background:rgba(15, 119, 255, 1);
              color: rgba(255, 255, 255, 1);
              font-weight: bold;
              font-size: 22px;
              cursor: pointer;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
              width: 150px;
            }

            .${this.options.prefix}splash-game-play>button:hover {
                background: linear-gradient(0deg, #1C8464, #21A179);
            }

            .${this.options.prefix}splash-game-play>button:active {
                box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
                background: linear-gradient(0deg, #1C8464, #15674E);
            }
                        
            .${this.options.prefix}loader,
            .${this.options.prefix}loader:after {
              border-radius: 50%;
              width: 1.5em;
              height: 1.5em;
            }

            .${this.options.prefix}loader {
              margin: 0px auto;
              font-size: 10px;
              position: relative;
              text-indent: -9999em;
              border-top: 1.1em solid rgba(255, 255, 255, 0.2);
              border-right: 1.1em solid rgba(255, 255, 255, 0.2);
              border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
              border-left: 1.1em solid #ffffff;
              -webkit-transform: translateZ(0);
              -ms-transform: translateZ(0);
              transform: translateZ(0);
              -webkit-animation: ${this.options.prefix}load8 1.1s infinite linear;
              animation: ${this.options.prefix}load8 1.1s infinite linear;
              display:none;
            }

            @-webkit-keyframes ${this.options.prefix}load8 {
              0% {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
              }
              100% {
                -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
              }
            }

            @keyframes ${this.options.prefix}load8 {
              0% {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
              }
              100% {
                -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
              }
            }

            @media screen and (max-height:600px) {
              .${this.options.prefix}splash-game-description{
                display:none;
              }
              
              .${this.options.prefix}splash-game-thumbnail>div{
                max-width:150px;
                max-height:150px;
              }            
            }

            @media screen and (min-width:600px){
              .${this.options.prefix}splash-center >.${this.options.prefix}splash-left{
                display:flex;
              }
              .${this.options.prefix}splash-center >.${this.options.prefix}splash-right{
                display:flex;
              }
              .${this.options.prefix}splash-game-title>p,.${this.options.prefix}splash-game-consent>p,.${this.options.prefix}splash-game-description>p{
                max-width:500px;
              }
            }

            @media screen and (min-height:600px){              
              .${this.options.prefix}splash-container >.${this.options.prefix}splash-top{
                display:flex;
              }
              .${this.options.prefix}splash-container >.${this.options.prefix}splash-bottom{
                display:flex;
              }        
            }
      `;

    return css;
  }

  _html(options, gameData) {
    const { isConsentDomain } = options;

    let html = '';
    let playButtonlang = gameData.loader.lang ? Language[gameData.loader.lang] : 'Play now';
    let consentStyle = isConsentDomain ? 'display:flex' : 'display:none';

    html = `
          <div class="${this.options.prefix}splash-container">
            <div class="${this.options.prefix}splash-center">   
              <div class="${this.options.prefix}splash-game">

                <div class="${this.options.prefix}splash-game-metadata">

                  
                  <div class="${this.options.prefix}splash-game-thumbnail-play">

                    <div class="${this.options.prefix}splash-game-thumbnail">   
                      <div></div>
                    </div>

                    <div class="${this.options.prefix}splash-game-title">                    
                      <p>${gameData.title}</p>
                    </div>

                    <div class="${this.options.prefix}splash-game-play">   
                      <button id="${this.options.prefix}splash-button">${playButtonlang}</button>
                      <div class="${this.options.prefix}loader">Loading...</div>    
                    </div> 
                  </div>

                </div>                                         
              </div>              
              <div id="${this.options.prefix}splash-slot-right" class="${this.options.prefix}splash-right"></div>              
            </div>            
            <div id="${this.options.prefix}splash-slot-bottom" class="${this.options.prefix}splash-bottom"></div>            
          </div>
      `;
    return html;
  }

  _insertHtml(html) {
    // Create our container and add the markup.
    const container = document.createElement('div');
    container.innerHTML = html;
    container.id = `${this.options.prefix}splash`;
    container.style['width'] = '100%';
    container.style['height'] = '100%';

    const extContainer = this._getExtContainer();

    if (extContainer) {
      extContainer.style.display = 'block';
      extContainer.style['width'] = '100%';
      extContainer.style['height'] = '100%';
      extContainer.insertBefore(container, extContainer.firstChild);
    } else {
      container.style['z-index'] = Layers.SplashContainer.zIndex;
      container.style['position'] = 'fixed';
      container.style['top'] = '0';
      container.style['left'] = '0';
      const body = document.body || document.getElementsByTagName('body')[0];
      body.insertBefore(container, body.firstChild);
    }

    return { container, extContainer };
  }

  _getBackground(options, gameData) {
    return `
     background-image: url('${this._getThumbnail(options, gameData)}?f=webp');
     background-repeat: no-repeat;
     background-position: center;
     background-size: cover;
     `;
  }

  _init_slots() {
    const slot_description = document.querySelector(
      `.${this.options.prefix}splash-game-description`,
    );
    if (!this.gameData.description && slot_description) slot_description.style.display = 'none';

    const slot_top = document.getElementById(`${this.options.prefix}splash-slot-top`);
    const slot_bottom = document.getElementById(`${this.options.prefix}splash-slot-bottom`);

    const slot_left = document.getElementById(`${this.options.prefix}splash-slot-left`);
    const slot_right = document.getElementById(`${this.options.prefix}splash-slot-right`);

    const display = this.gameData.dads;
    const enabled = display.enabled;

    const slot_top_enabled = enabled && display.top && display.top.enabled;
    const slot_bottom_enabled = enabled && display.bottom && display.bottom.enabled;
    const slot_left_enabled = enabled && display.left && display.left.enabled;
    const slot_right_enabled = enabled && display.right && display.right.enabled;

    if (slot_top) {
      if (!slot_top_enabled) slot_top.style.display = 'none';
      else this._observe_visibility(slot_top);
    }

    if (slot_bottom) {
      if (!slot_bottom_enabled) slot_bottom.style.display = 'none';
      else this._observe_visibility(slot_bottom);
    }

    if (slot_left) {
      if (!slot_left_enabled) slot_left.style.display = 'none';
      else this._observe_visibility(slot_left);
    }

    if (slot_right) {
      if (!slot_right_enabled) slot_right.style.display = 'none';
      else this._observe_visibility(slot_right);
    }

    this._slots = {
      top: slot_top,
      bottom: slot_bottom,
      left: slot_left,
      right: slot_right,
    };
  }

  _observe_visibility(el) {
    if (!IntersectionObserver) return;

    let options = {
      root: el.parent,
      rootMargin: '0px',
      threshold: 0.5,
    };

    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        this.emit('slotVisibilityChanged', {
          id: entry.target.id,
          visible: entry.isIntersecting,
        });
      });
    }, options);

    observer.observe(el);
  }
}

export default Ga8Custom;
